<template>
  <div class="sfjs-iframe-container">
    <iframe 
      :src="iframeSrc" 
      width="100%" 
      height="100%" 
      frameborder="0"
      scrolling="auto"
    ></iframe>
  </div>
</template>

<script>
export default {
  name: 'SfjsIframe',
  data() {
    return {
      iframeSrc: ''
    }
  },
  mounted() {
    this.updateIframeSrc()
    window.addEventListener('resize', this.updateIframeSrc)
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.updateIframeSrc)
  },
  methods: {
    // 读取cookie
    getCookie(name) {
      const nameEQ = name + '='
      const ca = document.cookie.split(';')
      for (let i = 0; i < ca.length; i++) {
        let c = ca[i]
        while (c.charAt(0) === ' ') c = c.substring(1, c.length)
        if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length)
      }
      return null
    },
    updateIframeSrc() {
      const screenWidth = window.innerWidth
      // 平板和手机的判断阈值，一般认为768px以下为移动设备
      const isMobile = screenWidth < 768
      
      // 读取cookie中的导航选项
      const activeNav = this.getCookie('activeNav')
      
      // 基础路径
      // let basePath = isMobile ? '/sfjsPhone' : '/sfjs'
      let basePath = '/sfjs'
      
      // 如果cookie中有保存的导航路径，则使用它
      if(isMobile){
        // 默认首页
        this.iframeSrc = basePath + '/index.html'
      }else{
        if (activeNav) {
          // 处理路径，确保格式正确
          let targetPath = activeNav
          
          // 如果以 ./ 开头，去掉 ./
          if (targetPath.startsWith('./')) {
            targetPath = targetPath.substring(2)
          }
          
          // 如果以 / 开头，直接使用
          if (targetPath.startsWith('/')) {
            this.iframeSrc = targetPath
          } else {
            // 否则拼接基础路径
            this.iframeSrc = basePath + '/' + targetPath
          }
        } else {
          // 默认首页
          this.iframeSrc = basePath + '/index.html'
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">
.sfjs-iframe-container {
  width: 100%;
  height: 100vh;
  overflow: hidden;
  position: relative;
}

iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: none;
}
</style>